/**
 * CancelAssessmentDialog - Cancel assessment confirmation dialog
 * Extracted from ReferralsPage to reduce file size
 */
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function CancelAssessmentDialog({
  open,
  onOpenChange,
  cancelReason,
  setCancelReason,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Cancel Assessment</DialogTitle>
          <DialogDescription>
            Are you sure you want to cancel this scheduled assessment?
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Reason for Cancellation</Label>
            <Textarea
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              placeholder="Enter reason for cancellation..."
              rows={2}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Keep Assessment
          </Button>
          <Button 
            className="bg-red-600 hover:bg-red-700"
            onClick={onSubmit}
          >
            Cancel Assessment
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
